import { Tabs } from 'antd';
import getFormatMessage from '../../../locales/get-format-message';

export enum OrganizationTab {
  Members = 'Members',
  Applications = 'Applications',
  Roles = 'Roles',
  Groups = 'Groups',
}

interface ITabItem {
  readonly key: OrganizationTab;
  readonly label: string;
}

interface IProps {
  readonly tabKey: OrganizationTab;
  readonly onChange: (tabKey: OrganizationTab) => void;
  readonly className: string;
  readonly membersLength: number;
  readonly applicationsLength: number;
  readonly rolesLength: number;
  readonly groupsLength: number;
}

export const OrganizationTabs = (props: IProps) => {
  const items: ITabItem[] = [
    {
      key: OrganizationTab.Members,
      label: `${getFormatMessage('members')} (${props.membersLength})`,
    },
    {
      key: OrganizationTab.Applications,
      label: `${getFormatMessage('applications')} (${
        props.applicationsLength
      })`,
    },
    {
      key: OrganizationTab.Groups,
      label: `${getFormatMessage('groups')} (${props.groupsLength})`,
    },
    {
      key: OrganizationTab.Roles,
      label: `${getFormatMessage('roles')} (${props.rolesLength})`,
    },
  ];

  const onTabChange = (key: string) => {
    props.onChange(key as unknown as OrganizationTab);
  };

  return (
    <div className={props.className}>
      <Tabs
        activeKey={props.tabKey as unknown as string}
        items={items as any}
        onChange={onTabChange}
      ></Tabs>
    </div>
  );
};
